import gql from 'graphql-tag';

export default gql`
query AutocompleteLocation($search: String!, $zipCode: String!) {
    autocompleteLocation(search: $search, zipCode: $zipCode)
}
`;